package org.multipaz.doctypes.generated

/**
 * Generated strings for language: zh-rCN
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_zh_rCN = mapOf(
    "age_verification_attribute_older_than_years" to "年满 {age} 岁",
    "age_verification_description_older_than_years" to "指示mDL持有人是否年满{age}周岁或以上",
    "age_verification_request_age_over_18" to "18岁以上",
    "age_verification_request_age_over_18_zkp" to "18岁以上 (ZKP)",
    "age_verification_request_age_over_21" to "21岁以上",
    "age_verification_request_age_over_21_zkp" to "21岁以上 (ZKP)",
    "age_verification_request_all_data_elements" to "所有数据元素",
    "document_display_name_age_verification" to "年龄验证",
    "document_display_name_driving_license" to "驾驶证",
    "document_display_name_eu_personal_id" to "个人身份证",
    "document_display_name_google_wallet_id_pass" to "Google 钱包身份凭证",
    "document_display_name_photo_id" to "照片身份证件",
    "document_display_name_vaccination_document" to "疫苗接种文件",
    "document_display_name_vehicle_registration" to "行车证",
    "driving_license_attribute_aamva_version_number" to "AAMVA 版本号",
    "driving_license_attribute_administrative_number" to "行政编号",
    "driving_license_attribute_age_in_years" to "年龄",
    "driving_license_attribute_alias_family_name" to "别名/又名 姓氏",
    "driving_license_attribute_alias_given_name" to "别名/又名 名字",
    "driving_license_attribute_alias_suffix" to "别名/又名 后缀名",
    "driving_license_attribute_audit_information" to "审计信息",
    "driving_license_attribute_biometric_template_face" to "面部生物特征模板",
    "driving_license_attribute_biometric_template_fingerprint" to "指纹生物特征模板",
    "driving_license_attribute_biometric_template_iris" to "生物识别虹膜模板",
    "driving_license_attribute_biometric_template_signature_sign" to "签名生物特征模板",
    "driving_license_attribute_compliance_type" to "合规类型",
    "driving_license_attribute_date_of_birth" to "出生日期",
    "driving_license_attribute_date_of_expiry" to "有效期至",
    "driving_license_attribute_date_of_issue" to "签发日期",
    "driving_license_attribute_domestic_driving_privileges" to "国内准驾权限",
    "driving_license_attribute_driving_privileges" to "驾驶权限",
    "driving_license_attribute_edl_indicator" to "EDL 指示器",
    "driving_license_attribute_eye_color" to "眼睛颜色",
    "driving_license_attribute_family_name" to "姓",
    "driving_license_attribute_family_name_national_characters" to "姓（本国文字）",
    "driving_license_attribute_family_name_truncation" to "姓氏省略",
    "driving_license_attribute_given_name_national_characters" to "名（本国文字）",
    "driving_license_attribute_given_name_truncation" to "名字省略",
    "driving_license_attribute_given_names" to "名",
    "driving_license_attribute_hair_color" to "头发颜色",
    "driving_license_attribute_hazmat_endorsement_expiration_date" to "HAZMAT 背书有效期",
    "driving_license_attribute_height" to "身高",
    "driving_license_attribute_issuing_authority" to "签发机关",
    "driving_license_attribute_issuing_country" to "签发国家",
    "driving_license_attribute_issuing_jurisdiction" to "签发辖区",
    "driving_license_attribute_license_number" to "驾驶证号码",
    "driving_license_attribute_limited_duration_document_indicator" to "有限期文件指示器",
    "driving_license_attribute_name_suffix" to "姓名后缀",
    "driving_license_attribute_nationality" to "国籍",
    "driving_license_attribute_older_than_13" to "年满 13 岁",
    "driving_license_attribute_older_than_16" to "年满 16 岁",
    "driving_license_attribute_older_than_18" to "年满 18 岁",
    "driving_license_attribute_older_than_21" to "年满 21 岁",
    "driving_license_attribute_older_than_25" to "年满 25 岁",
    "driving_license_attribute_older_than_60" to "年满 60 岁",
    "driving_license_attribute_older_than_62" to "年满 62 岁",
    "driving_license_attribute_older_than_65" to "65岁以上",
    "driving_license_attribute_older_than_68" to "68岁以上",
    "driving_license_attribute_organ_donor" to "器官捐献",
    "driving_license_attribute_photo_of_holder" to "持证人照片",
    "driving_license_attribute_place_of_birth" to "出生地",
    "driving_license_attribute_portrait_image_timestamp" to "证件照时间戳",
    "driving_license_attribute_race_ethnicity" to "种族/民族",
    "driving_license_attribute_resident_address" to "居住地址",
    "driving_license_attribute_resident_city" to "居住城市",
    "driving_license_attribute_resident_country" to "居住国家",
    "driving_license_attribute_resident_county" to "居住县",
    "driving_license_attribute_resident_postal_code" to "居住邮政编码",
    "driving_license_attribute_resident_state" to "居住省/州",
    "driving_license_attribute_sex" to "性别",
    "driving_license_attribute_signature_usual_mark" to "签名/常用标记",
    "driving_license_attribute_un_distinguishing_sign" to "联合国识别标志",
    "driving_license_attribute_veteran" to "退伍军人",
    "driving_license_attribute_weight" to "体重",
    "driving_license_attribute_weight_range" to "体重范围",
    "driving_license_attribute_year_of_birth" to "出生年份",
    "driving_license_description_aamva_version_number" to "识别AAMVA mDL数据元素集版本的数字。",
    "driving_license_description_administrative_number" to "颁发机构分配的审计控制编号。",
    "driving_license_description_age_in_years" to "mDL持有人的年龄",
    "driving_license_description_alias_family_name" to "凭证持有人所知的其他姓氏。",
    "driving_license_description_alias_given_name" to "凭证持有人所知的其他名字。",
    "driving_license_description_alias_suffix" to "凭证持有人所知的其他后缀。",
    "driving_license_description_audit_information" to "用于识别凭证最初发放时间、地点和发放者的字母和/或数字字符串。",
    "driving_license_description_biometric_template_face" to "mDL持有人的面部生物识别信息",
    "driving_license_description_biometric_template_fingerprint" to "mDL持有人的指纹",
    "driving_license_description_biometric_template_iris" to "mDL持有人的虹膜",
    "driving_license_description_biometric_template_signature_sign" to "mDL持有人的签名",
    "driving_license_description_compliance_type" to "DHS必填字段，表示合规性",
    "driving_license_description_date_of_birth" to "mDL 持有人的出生日期。如未知，提供大概出生日期。",
    "driving_license_description_date_of_expiry" to "mDL 的到期日期",
    "driving_license_description_date_of_issue" to "mDL 的签发日期",
    "driving_license_description_domestic_driving_privileges" to "驾照持有人获授权驾驶的车辆类型",
    "driving_license_description_driving_privileges" to "mDL持有人的驾驶权限。",
    "driving_license_description_edl_indicator" to "凭证为EDL时显示。",
    "driving_license_description_eye_color" to "mDL持有人的眼睛颜色。",
    "driving_license_description_family_name" to "mDL 持有人的姓氏、家族名或主要身份标识符。",
    "driving_license_description_family_name_national_characters" to "mDL 持有人的姓氏",
    "driving_license_description_family_name_truncation" to "一个代码，表示该字段是否已截断",
    "driving_license_description_given_name_national_characters" to "mDL 持有人的名字",
    "driving_license_description_given_name_truncation" to "一个代码，表示名字或中间名是否已截断",
    "driving_license_description_given_names" to "mDL 持有人的名字、其他姓名或次要身份标识符",
    "driving_license_description_hair_color" to "mDL持有人的发色",
    "driving_license_description_hazmat_endorsement_expiration_date" to "证件授予的危险材料背书失效日期。",
    "driving_license_description_height" to "mDL持有人的身高（厘米）。",
    "driving_license_description_issuing_authority" to "颁发机构名称。",
    "driving_license_description_issuing_country" to "签发机构所在国家或地区的 Alpha-2 国家代码 (ISO 3166-1 定义)",
    "driving_license_description_issuing_jurisdiction" to "签发mDL的司法管辖区国家行政区代码",
    "driving_license_description_license_number" to "颁发机构分配或计算的号码。",
    "driving_license_description_limited_duration_document_indicator" to "DHS必填字段，表示凭证持有人是否具有临时合法身份。1：临时合法身份",
    "driving_license_description_name_suffix" to "获发驾照或身份证明文件的人员的姓名后缀。",
    "driving_license_description_nationality" to "移动驾照持有人的国籍",
    "driving_license_description_older_than_13" to "指示mDL持有人是否年满13周岁或以上",
    "driving_license_description_older_than_16" to "指示mDL持有人是否年满16周岁或以上",
    "driving_license_description_older_than_18" to "指示mDL持有人是否年满18周岁或以上",
    "driving_license_description_older_than_21" to "指示mDL持有人是否年满21周岁或以上",
    "driving_license_description_older_than_25" to "表明移动驾照持有人是否年满25周岁或以上",
    "driving_license_description_older_than_60" to "表明移动驾照持有人是否年满60周岁或以上",
    "driving_license_description_older_than_62" to "表明移动驾照持有人是否年满62周岁或以上",
    "driving_license_description_older_than_65" to "表明移动驾照持有人是否年满65周岁或以上",
    "driving_license_description_older_than_68" to "表明移动驾照持有人是否年满68周岁或以上",
    "driving_license_description_organ_donor" to "表明证件持有人是否为器官捐献者的指示。",
    "driving_license_description_photo_of_holder" to "mDL持有人的肖像复制件。",
    "driving_license_description_place_of_birth" to "mDL持有人的出生国家和市/省/州",
    "driving_license_description_portrait_image_timestamp" to "肖像拍摄日期",
    "driving_license_description_race_ethnicity" to "持卡人的种族或民族代码",
    "driving_license_description_resident_address" to "mDL持有人的居住和/或联系地址（街道/门牌号、市等）",
    "driving_license_description_resident_city" to "移动驾照持有人的居住城市",
    "driving_license_description_resident_country" to "mDL 持有人居住的国家",
    "driving_license_description_resident_county" to "mDL持有人居住县的3位县代码",
    "driving_license_description_resident_postal_code" to "移动驾照持有人的邮政编码",
    "driving_license_description_resident_state" to "移动驾照持有人的居住州/省/区",
    "driving_license_description_sex" to "mDL持有人的性别。",
    "driving_license_description_signature_usual_mark" to "mDL 持有人的签名或常用标记图像，",
    "driving_license_description_un_distinguishing_sign" to "颁发国家识别标志。",
    "driving_license_description_veteran" to "表明证件持有人是否为退伍军人的指示。",
    "driving_license_description_weight" to "mDL持有人的体重（千克）。",
    "driving_license_description_weight_range" to "表示持卡人的大致体重范围",
    "driving_license_description_year_of_birth" to "mDL持有人的出生年份",
    "driving_license_request_age_over_18" to "年龄超过 18 岁",
    "driving_license_request_age_over_18_and_portrait" to "年龄超过 18 岁 + 头像",
    "driving_license_request_age_over_18_and_portrait_equivalence" to "年满18周岁 + 照片一致性",
    "driving_license_request_age_over_18_and_portrait_or_portrait_equivalence" to "年满18周岁 + (照片 或 照片一致性)",
    "driving_license_request_age_over_18_zkp" to "年龄超过 18 岁 (ZKP)",
    "driving_license_request_age_over_21" to "年龄超过 21 岁",
    "driving_license_request_age_over_21_and_portrait" to "年龄超过 21 岁 + 头像",
    "driving_license_request_age_over_21_zkp" to "年龄超过 21 岁 (ZKP)",
    "driving_license_request_all_data_elements" to "所有数据元素",
    "driving_license_request_mandatory_data_elements" to "必填数据元素",
    "driving_license_request_name_and_address_all_stored" to "姓名和地址（全部已存储）",
    "driving_license_request_name_and_address_partially_stored" to "姓名和地址（部分已存储）",
    "driving_license_request_us_transportation" to "美国交通",
    "eu_personal_id_attribute_address" to "地址",
    "eu_personal_id_attribute_age_in_years" to "年龄（岁）",
    "eu_personal_id_attribute_city_of_birth" to "出生城市",
    "eu_personal_id_attribute_country_of_birth" to "出生国家",
    "eu_personal_id_attribute_date_of_birth" to "出生日期",
    "eu_personal_id_attribute_date_of_expiry" to "有效期至",
    "eu_personal_id_attribute_date_of_issue" to "签发日期",
    "eu_personal_id_attribute_document_number" to "证件号码",
    "eu_personal_id_attribute_email_address_of_holder" to "持证人电子邮箱",
    "eu_personal_id_attribute_family_name" to "姓氏",
    "eu_personal_id_attribute_family_name_at_birth" to "出生时姓氏",
    "eu_personal_id_attribute_first_name_at_birth" to "出生时名字",
    "eu_personal_id_attribute_given_names" to "名字",
    "eu_personal_id_attribute_issuing_authority" to "签发机构",
    "eu_personal_id_attribute_issuing_country" to "签发国家",
    "eu_personal_id_attribute_issuing_jurisdiction" to "签发管辖区",
    "eu_personal_id_attribute_mobile_phone_of_holder" to "持证人手机号",
    "eu_personal_id_attribute_nationality" to "国籍",
    "eu_personal_id_attribute_older_than_18" to "年龄大于 18 岁",
    "eu_personal_id_attribute_older_than_21" to "年龄大于 21 岁",
    "eu_personal_id_attribute_older_than_age_attestations" to "大于指定年龄证明",
    "eu_personal_id_attribute_personal_administrative_number" to "个人行政编号",
    "eu_personal_id_attribute_photo_of_holder" to "持证人照片",
    "eu_personal_id_attribute_place_of_birth" to "出生地",
    "eu_personal_id_attribute_resident_address" to "居住地址",
    "eu_personal_id_attribute_resident_city" to "居住城市",
    "eu_personal_id_attribute_resident_country" to "居住国家",
    "eu_personal_id_attribute_resident_house_number" to "居住门牌号",
    "eu_personal_id_attribute_resident_postal_code" to "居住邮政编码",
    "eu_personal_id_attribute_resident_state" to "居住州/省",
    "eu_personal_id_attribute_resident_street" to "居住街道",
    "eu_personal_id_attribute_sex" to "性别",
    "eu_personal_id_attribute_state_of_birth" to "出生省份",
    "eu_personal_id_attribute_year_of_birth" to "出生年份",
    "eu_personal_id_description_address" to "地址",
    "eu_personal_id_description_age_in_years" to "PID持有人的年龄（以年为单位）",
    "eu_personal_id_description_city_of_birth" to "PID用户出生的市、城镇或乡村",
    "eu_personal_id_description_country_of_birth" to "PID用户出生国家（ISO 3166-1中规定的两位国家代码）",
    "eu_personal_id_description_date_of_birth" to "PID持有人的出生日、月和年。如果未知，则为近似出生日期。",
    "eu_personal_id_description_date_of_expiry" to "有效期（及时间）",
    "eu_personal_id_description_date_of_issue" to "签发日期（及时间）",
    "eu_personal_id_description_document_number" to "由 PID 提供方分配的 PID 编号。",
    "eu_personal_id_description_email_address_of_holder" to "相关人员的电子邮件地址（遵循 [RFC 5322] 规定）。",
    "eu_personal_id_description_family_name" to "PID持有人的当前姓氏或主要身份识别符",
    "eu_personal_id_description_family_name_at_birth" to "PID持有人的出生姓氏、家族名或主要身份标识",
    "eu_personal_id_description_first_name_at_birth" to "PID持有人的出生名字、其他名字或次要身份标识",
    "eu_personal_id_description_given_names" to "PID持有人的当前名字、其他名字或次要身份识别符",
    "eu_personal_id_description_issuing_authority" to "签发此 PID 的行政机构名称；若无单独签发机构，则为相关成员国的 ISO 3166 Alpha-2 国家代码。",
    "eu_personal_id_description_issuing_country" to "签发机构所属国家或地区的 ISO 3166-1 Alpha-2 国家代码。",
    "eu_personal_id_description_issuing_jurisdiction" to "签发此 PID 的司法管辖区的国家行政区划代码（遵循 ISO 3166-2:2020 第 8 条规定）。此代码的第一部分应与签发国家的值相同。",
    "eu_personal_id_description_mobile_phone_of_holder" to "相关用户的手机号码，以\"+\"符号作为国际代码前缀和国家代码开头，后跟纯数字。",
    "eu_personal_id_description_nationality" to "按照 ISO 3166-1 规定的 Alpha-2 国家代码，代表持证人的国籍。",
    "eu_personal_id_description_older_than_18" to "年龄是否超过18岁？",
    "eu_personal_id_description_older_than_21" to "年龄是否超过21岁？",
    "eu_personal_id_description_older_than_age_attestations" to "年龄验证",
    "eu_personal_id_description_personal_administrative_number" to "由 PID 提供方分配，用于审计控制或其他目的的编号。",
    "eu_personal_id_description_photo_of_holder" to "PID 持有人的肖像照片。",
    "eu_personal_id_description_place_of_birth" to "PID持有人的出生国家、市或州/省",
    "eu_personal_id_description_resident_address" to "持证人当前居住地和/或联系的完整地址（街道/门牌号、市镇等）",
    "eu_personal_id_description_resident_city" to "持证人当前居住的城市",
    "eu_personal_id_description_resident_country" to "持证人当前居住国家，采用 ISO 3166-1 规定的 Alpha-2 国家代码",
    "eu_personal_id_description_resident_house_number" to "持证人当前居住的门牌号，包括任何前缀或后缀",
    "eu_personal_id_description_resident_postal_code" to "持证人当前居住地的邮政编码",
    "eu_personal_id_description_resident_state" to "持证人当前居住的州、省、区或当地区域。",
    "eu_personal_id_description_resident_street" to "持证人当前居住的街道名称。",
    "eu_personal_id_description_sex" to "持证人的性别",
    "eu_personal_id_description_state_of_birth" to "PID用户出生的州、省、区或当地区域",
    "eu_personal_id_description_year_of_birth" to "PID持有人的出生年份",
    "eu_personal_id_request_age_over_18" to "18岁以上",
    "eu_personal_id_request_age_over_18_and_portrait" to "18岁以上 + 照片",
    "eu_personal_id_request_age_over_18_and_portrait_equivalence" to "年满18周岁 + 照片一致性",
    "eu_personal_id_request_age_over_18_and_portrait_or_portrait_equivalence" to "年满18周岁 + (照片 或 照片一致性)",
    "eu_personal_id_request_age_over_18_zkp" to "18岁以上 (ZKP)",
    "eu_personal_id_request_all_data_elements" to "所有数据要素",
    "eu_personal_id_request_mandatory_data_elements" to "强制性数据要素",
    "eu_personal_id_request_name_and_portrait" to "姓名 + 照片",
    "eu_personal_id_request_name_and_portrait_equivalence" to "姓名 + 照片一致性",
    "eu_personal_id_request_name_and_portrait_or_portrait_equivalence" to "姓名 + (照片 或 照片一致性)",
    "id_pass_request_age_over_18" to "年龄超过 18 岁",
    "id_pass_request_age_over_18_and_portrait" to "年满18岁 + 人像",
    "id_pass_request_age_over_18_and_portrait_equivalence" to "年满18周岁 + 照片一致性",
    "id_pass_request_age_over_18_and_portrait_or_portrait_equivalence" to "年满18周岁 + (人像或人像等效)",
    "id_pass_request_age_over_18_zkp" to "年龄超过 18 岁 (ZKP)",
    "id_pass_request_age_over_21" to "年龄超过 21 岁",
    "id_pass_request_age_over_21_and_portrait" to "年满21岁 + 人像",
    "id_pass_request_age_over_21_zkp" to "年龄超过 21 岁 (ZKP)",
    "id_pass_request_all_data_elements" to "全部数据项",
    "id_pass_request_mandatory_data_elements" to "必填数据项",
    "multi_request_age_over_18_mdl_or_pid" to "通过mDL或PID及交易验证年满18岁",
    "multi_request_mdl_and_photoid" to "mDL 和 照片ID",
    "multi_request_mdl_or_photoid" to "mDL 或 照片ID",
    "multi_request_payment_and_age_over_18" to "支付和年满18岁",
    "photo_id_attribute_administrative_number" to "行政编号",
    "photo_id_attribute_age_in_years" to "年龄",
    "photo_id_attribute_birth_city" to "出生城市",
    "photo_id_attribute_birth_country" to "出生国家",
    "photo_id_attribute_birth_state" to "出生省份",
    "photo_id_attribute_date_of_birth" to "出生日期",
    "photo_id_attribute_date_of_expiry" to "到期日期",
    "photo_id_attribute_date_of_issue" to "签发日期",
    "photo_id_attribute_document_number" to "证件号码",
    "photo_id_attribute_dtc_vc_version" to "DTC-VC 版本",
    "photo_id_attribute_emrtd_dg1" to "eMRTD DG1",
    "photo_id_attribute_emrtd_dg10" to "eMRTD DG10",
    "photo_id_attribute_emrtd_dg11" to "eMRTD DG11",
    "photo_id_attribute_emrtd_dg12" to "eMRTD DG12",
    "photo_id_attribute_emrtd_dg13" to "eMRTD DG13",
    "photo_id_attribute_emrtd_dg14" to "eMRTD DG14",
    "photo_id_attribute_emrtd_dg15" to "eMRTD DG15",
    "photo_id_attribute_emrtd_dg16" to "eMRTD DG16",
    "photo_id_attribute_emrtd_dg2" to "eMRTD DG2",
    "photo_id_attribute_emrtd_dg3" to "eMRTD DG3",
    "photo_id_attribute_emrtd_dg4" to "eMRTD DG4",
    "photo_id_attribute_emrtd_dg5" to "eMRTD DG5",
    "photo_id_attribute_emrtd_dg6" to "eMRTD DG6",
    "photo_id_attribute_emrtd_dg7" to "eMRTD DG7",
    "photo_id_attribute_emrtd_dg8" to "eMRTD DG8",
    "photo_id_attribute_emrtd_dg9" to "eMRTD DG9",
    "photo_id_attribute_emrtd_sod" to "eMRTD SOD",
    "photo_id_attribute_family_name" to "姓",
    "photo_id_attribute_family_name_latin1" to "姓氏",
    "photo_id_attribute_family_name_viz" to "姓 (VIZ)",
    "photo_id_attribute_given_name_viz" to "名 (VIZ)",
    "photo_id_attribute_given_names" to "名",
    "photo_id_attribute_given_names_latin1" to "名字",
    "photo_id_attribute_issuing_authority" to "签发机构",
    "photo_id_attribute_issuing_country" to "签发国家",
    "photo_id_attribute_issuing_subdivision" to "签发分区",
    "photo_id_attribute_name_at_birth" to "出生姓名",
    "photo_id_attribute_nationality" to "国籍",
    "photo_id_attribute_person_id" to "个人ID",
    "photo_id_attribute_photo_of_holder" to "持证人照片",
    "photo_id_attribute_place_of_birth" to "出生地",
    "photo_id_attribute_portrait_capture_date" to "肖像拍摄日期",
    "photo_id_attribute_resident_address" to "居住地址",
    "photo_id_attribute_resident_city" to "居住城市",
    "photo_id_attribute_resident_city_latin1" to "居住城市",
    "photo_id_attribute_resident_country" to "居住国家",
    "photo_id_attribute_resident_house_number" to "居住门牌号",
    "photo_id_attribute_resident_postal_code" to "居住邮政编码",
    "photo_id_attribute_resident_state" to "居住地州省",
    "photo_id_attribute_resident_street" to "居住街道",
    "photo_id_attribute_sex" to "性别",
    "photo_id_attribute_travel_document_mrz" to "旅行证件机读区",
    "photo_id_attribute_travel_document_number" to "旅行证件号码",
    "photo_id_attribute_travel_document_type" to "旅行证件类型",
    "photo_id_attribute_year_of_birth" to "出生年份",
    "photo_id_description_administrative_number" to "照片ID签发机构出于审计控制或其他目的分配的号码",
    "photo_id_description_age_in_years" to "证件持有人的年龄",
    "photo_id_description_birth_city" to "照片ID持有人出生所在的直辖市、市、镇或村庄",
    "photo_id_description_birth_country" to "照片证件持有人的出生国家，使用 ISO 3166-1 中指定的 Alpha-2 国家代码",
    "photo_id_description_birth_state" to "照片证件持有人的出生州、省、区或当地区域",
    "photo_id_description_date_of_birth" to "证件持有人的出生日期。如未知，请填写大概出生日期",
    "photo_id_description_date_of_expiry" to "证件到期日期",
    "photo_id_description_date_of_issue" to "证件签发日期",
    "photo_id_description_document_number" to "由签发机构分配或计算的号码",
    "photo_id_description_dtc_vc_version" to "DTC-VC定义的版本",
    "photo_id_description_emrtd_dg1" to "数据组 1：个人信息（机读区中记录的数据）C",
    "photo_id_description_emrtd_dg10" to "数据组 10：物质特征",
    "photo_id_description_emrtd_dg11" to "数据组 11：额外的个人详细信息",
    "photo_id_description_emrtd_dg12" to "数据组 12：额外的证件详细信息",
    "photo_id_description_emrtd_dg13" to "数据组 13：可选详细信息",
    "photo_id_description_emrtd_dg14" to "数据组 14：安全选项",
    "photo_id_description_emrtd_dg15" to "数据组 15：主动认证公钥信息",
    "photo_id_description_emrtd_dg16" to "数据组 16：通知对象",
    "photo_id_description_emrtd_dg2" to "数据组 2：参考肖像（编码人脸）",
    "photo_id_description_emrtd_dg3" to "数据组 3：编码指纹",
    "photo_id_description_emrtd_dg4" to "数据组 4：编码眼睛",
    "photo_id_description_emrtd_dg5" to "数据组 5：显示肖像",
    "photo_id_description_emrtd_dg6" to "数据组 6：预留作将来使用",
    "photo_id_description_emrtd_dg7" to "数据组 7：显示签名或惯用标记",
    "photo_id_description_emrtd_dg8" to "数据组 8：数据特征",
    "photo_id_description_emrtd_dg9" to "数据组 9：结构特征",
    "photo_id_description_emrtd_sod" to "eMRTD证件安全对象的二进制数据",
    "photo_id_description_family_name" to "证件持有人的姓氏或主要标识符",
    "photo_id_description_family_name_latin1" to "证件持有人的姓氏或主要身份标识",
    "photo_id_description_family_name_viz" to "ICAO 9303 中 VIZ（目视检查区）定义的姓氏",
    "photo_id_description_given_name_viz" to "ICAO 9303 中 VIZ（目视检查区）定义的给定名",
    "photo_id_description_given_names" to "证件持有人的名、其他名称或次要标识符",
    "photo_id_description_given_names_latin1" to "证件持有人的名字或其他身份标识",
    "photo_id_description_issuing_authority" to "签发机构名称",
    "photo_id_description_issuing_country" to "签发机构国家或地区的ISO 3166-1 Alpha-2 国家代码",
    "photo_id_description_issuing_subdivision" to "ISO 3166-2 定义的细分代码，用于签发移动电子身份证件的机构或其所在地",
    "photo_id_description_name_at_birth" to "证件持有人的出生姓名",
    "photo_id_description_nationality" to "证件持有人的国籍",
    "photo_id_description_person_id" to "照片证件持有人的个人标识符",
    "photo_id_description_photo_of_holder" to "证件持有人的肖像复制件",
    "photo_id_description_place_of_birth" to "证件持有人的出生国家、市或省/州",
    "photo_id_description_portrait_capture_date" to "肖像拍摄日期",
    "photo_id_description_resident_address" to "证件持有人的居住和/或联系地址（街道/门牌号、市/区等）",
    "photo_id_description_resident_city" to "证件持有人居住的城市/市（或等同行政区划）",
    "photo_id_description_resident_city_latin1" to "持有人居住的城市/市（或等效行政区）",
    "photo_id_description_resident_country" to "证件持有人的居住国家",
    "photo_id_description_resident_house_number" to "照片ID持有人当前居住的门牌号，包括任何前缀或后缀",
    "photo_id_description_resident_postal_code" to "证件持有人的邮政编码",
    "photo_id_description_resident_state" to "照片ID持有人居住的州/省/区",
    "photo_id_description_resident_street" to "照片ID持有人当前居住的街道名称",
    "photo_id_description_sex" to "证件持有人的性别",
    "photo_id_description_travel_document_mrz" to "作为实体证件上打印文本的机器可读区",
    "photo_id_description_travel_document_number" to "与照片ID关联的旅行证件号码（如与旅行证件关联或派生自旅行证件）",
    "photo_id_description_travel_document_type" to "源文件类型标识符（如与旅行证件关联或派生自旅行证件）",
    "photo_id_description_year_of_birth" to "证件持有人的出生年份",
    "photo_id_request_age_over_18" to "年满 18 岁",
    "photo_id_request_age_over_18_and_portrait" to "年满 18 岁 + 人像",
    "photo_id_request_age_over_18_and_portrait_equivalence" to "年满18周岁 + 照片一致性",
    "photo_id_request_age_over_18_and_portrait_or_portrait_equivalence" to "年满18周岁 + (照片 或 照片一致性)",
    "photo_id_request_age_over_18_zkp" to "年满 18 岁 (ZKP)",
    "photo_id_request_all_data_elements" to "所有数据元素",
    "photo_id_request_mandatory_data_elements" to "必填数据项",
    "vaccination_attribute_birth_day" to "出生日",
    "vaccination_attribute_birth_month" to "出生月份",
    "vaccination_attribute_birth_year" to "出生年份",
    "vaccination_attribute_covid19_first_vaccination" to "RA01 首针疫苗",
    "vaccination_attribute_covid19_second_vaccination" to "RA01 第二针疫苗",
    "vaccination_attribute_covid19_test" to "新冠病毒检测事件",
    "vaccination_attribute_covid19_vaccinated" to "COVID-19疫苗接种",
    "vaccination_attribute_date_of_birth" to "出生日期",
    "vaccination_attribute_facial_image" to "面部图像",
    "vaccination_attribute_family_name" to "姓氏",
    "vaccination_attribute_family_name_initial" to "姓氏首字母",
    "vaccination_attribute_given_name" to "名字",
    "vaccination_attribute_given_name_initial" to "名字首字母",
    "vaccination_attribute_id_with_drivers_license_number" to "驾驶证号码身份证明",
    "vaccination_attribute_id_with_passport_number" to "护照号码身份证明",
    "vaccination_attribute_safe_entry_leisure" to "安全入场指示",
    "vaccination_attribute_sex" to "性别",
    "vaccination_attribute_yellow_fever_vaccinated" to "黄热病疫苗接种",
    "vaccination_description_birth_day" to "持有者出生日",
    "vaccination_description_birth_month" to "持有者出生月份",
    "vaccination_description_birth_year" to "持有者出生年份",
    "vaccination_description_covid19_first_vaccination" to "新冠疫苗 - 首剂接种数据",
    "vaccination_description_covid19_second_vaccination" to "新冠疫苗 - 第二剂接种数据",
    "vaccination_description_covid19_test" to "证明持有人新冠病毒检测结果为阴性",
    "vaccination_description_covid19_vaccinated" to "证明持有人已完全接种新冠疫苗",
    "vaccination_description_date_of_birth" to "持有者出生日期",
    "vaccination_description_facial_image" to "持有者面部照片",
    "vaccination_description_family_name" to "持有者姓氏",
    "vaccination_description_family_name_initial" to "持有者姓氏首字母",
    "vaccination_description_given_name" to "持有者名字",
    "vaccination_description_given_name_initial" to "持有者名字首字母",
    "vaccination_description_id_with_drivers_license_number" to "通过驾驶证号识别持有者的唯一信息集",
    "vaccination_description_id_with_passport_number" to "通过护照号识别持有者的唯一信息集",
    "vaccination_description_safe_entry_leisure" to "证明持有人符合休闲场合安全通行的特定要求（未披露具体依据是疫苗接种、康复还是阴性检测）",
    "vaccination_description_sex" to "性别",
    "vaccination_description_yellow_fever_vaccinated" to "证明持有人已完全接种黄热病疫苗",
    "vehicle_registration_attribute_basic_vehicle_info" to "车辆基本信息",
    "vehicle_registration_attribute_issue_date" to "签发日期",
    "vehicle_registration_attribute_registration_holder" to "行车证持有人信息",
    "vehicle_registration_attribute_registration_info" to "行车证信息",
    "vehicle_registration_attribute_vin" to "车辆识别号",
    "vehicle_registration_description_basic_vehicle_info" to "此数据元素包含车辆基本信息。",
    "vehicle_registration_description_issue_date" to "文件签发日期",
    "vehicle_registration_description_registration_holder" to "此数据元素用于识别注册证书持有人。",
    "vehicle_registration_description_registration_info" to "此数据元素包含常见的车辆注册信息，包括联合国/欧盟元素A和H。",
    "vehicle_registration_description_vin" to "车辆制造商定义的车辆识别号。"
)
